import { $axios, apiList } from '@/api'

export default {
    actions: {
        getFolders(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.folder.getFolders.method,
                    params: {
                        wsfunction: apiList.folder.getFolders.moodle_method,
                        courseids: [payload]
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        viewFolder(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.folder.viewFolder.method,
                    params: {
                        wsfunction: apiList.folder.viewFolder.moodle_method,
                        folderid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
    }
}
